<style lang="stylus">
    .tpl-search
        width 100%
        position absolute
        top -90px
        display flex
        justify-content center
        flex-wrap wrap
        &.tpl-search-en
            top -120px

        &.short-search
            position fixed
            top 0
            background #f1f3fb
            z-index 10
            transition top .25s ease-in-out

            .tpl-searchbox
                width 388px
                margin 24px 0

        &.short-search.pc-search
            page_background()
        &.short-search.pcview-tplsearch
            background #fff !important

        .tpl-searchbox
            position relative
            width 560px
            margin 24px auto 22px

        .tpl-search--icon
            position absolute
            right 0px
            top 0px
            height 40px
            display flex
            justify-content center
            align-items center
            padding-right 15px
            border-top-right-radius 20px
            border-bottom-right-radius 20px
            cursor pointer
            svg
                stroke #1D1E28

        .tpl-clean--icon
            display none
            justify-content center
            align-items center
            cursor pointer
            position absolute
            right 44px
            top 8px
            width 24px
            height 24px
            &.active
                display flex
            svg
                width 24px
                height 24px

        .tpl-search--input
            .ivu-select-dropdown
                width 100% !important
                left 0 !important
                min-width auto !important
                padding 5px 16px

        .ivu-input
            border-radius 20px
            max-width 700px
            height 40px
            padding-left 15px
            padding-right 50px
            font-size 14px

            &:hover, &:focus
                border-color var(--themeColor)
                box-shadow unset
            &::-webkit-input-placeholder
                font-size 14px
                color #909090

        .tpl-search--hots
            position absolute
            top 0
            right 46px
            height 100%
            display flex
            justify-content flex-end
            align-items center

        .tpl-search--hot
            padding 5px 8px 4px 8px
            margin-left 8px
            border-radius 15px
            background #eee
            height 16px
            font-size 12px
            cursor pointer
            transition all $transition-time $ease-in-out

            &:hover
                color #00be84 !important
                background #e8f9f3
        .ivu-select-dropdown
            .ivu-select-item
                display inline-block
                font-size 14px !important
                padding 8px 16px
                background-color #F4F4F4
                border-radius 4px
                margin 16px 4px
                max-width 102px
                overflow hidden
                text-overflow ellipsis
    .auto-complete--history-ope
        display flex
        justify-content space-between
        border-bottom 1px solid #F0F0F0
        padding 8px 0
        font-size 14px

    .auto-complete--history-ope--icon
        display flex
        align-items center
        cursor pointer
        transition all $transition-time $ease-in-out

        &:hover
            color #00be84
    .tpl-search--trending
        display flex
        justify-content center
        width 100%
        margin 0 auto
        overflow hidden
        @media screen and (max-width: 500px)
            display none
        >div
            display flex
            >p
                font-size 12px
                color rgba(0,0,0,.8)
                line-height 19px
                margin-right 10px
                @media screen and (max-width: 900px)
                    font-size 12px
            ul
                display flex
                flex-wrap wrap
                list-style none
                li
                    margin-right 10px
                    cursor pointer

                    p
                        font-size 12px
                        color rgba(0,0,0,.8)
                        line-height 19px

    .ivu-dropdown.tpl-search-dropdown
        position relative
        margin 24px 0
        margin-left 32px
        height 40px

        .search-dropdown-title
            display flex
            align-items center
            padding 0 16px
            height 40px
            background linear-gradient(270deg, #CEE4FB 0.93%, rgba(206, 228, 251, 0.6) 98.15%)
            border-radius 40px
            color #0977EA
            cursor pointer

            .dropdown-svgicon
                width 16px
                height 16px
                margin-right 5px
                pointer-events none

            p
                pointer-events none

    .search-dropItem
        display flex
        justify-content space-between
        padding 10px 10px 10px 16px !important
        align-items center
        min-width 132px

        .search-dropItem-text
            margin-right 10px

    .hot-list-item
        cursor pointer
        padding 9px 0
        li
            padding 9px 0
            &:nth-child(1)
                .hot-id
                    background #EA5636
            &:nth-child(2)
                .hot-id
                    background #F98A23
            &:nth-child(3)
                .hot-id
                    background #FBCA1F

    .hot-id
        color #fff
        border-radius 2px
        padding 2px 5px
        font-size 12px
        margin-right 16px
        background #C6C6C6

    @keyframes aaa
        0%
            top -80px
        100%
            top 0

    .dark-theme_search
        .ivu-select-dropdown
            background-color #404040
            .ivu-select-item
                background #555555
                color #fff
        .ivu-auto-complete
            color #fff
            input
                border none
                color #fff
                background #333
        .tpl-search--icon
            svg
                stroke #fff
        &.short-search.pc-search
            background #1e1e20 !important
        .auto-complete--history-ope
            color rgba(255,255,255,.5)
            border-bottom 1px solid #333333
        .search-dropItem
            .search-dropItem-text
                color #fff
            &:hover
                background #555555
        &.short-search.pcview-tplsearch
            background #222427 !important
</style>

<template>
    <div
        class="tpl-search"
        :class="{
            'short-search': showSearch,
            'tpl-search-en': !internal,
            'dark-theme_search': isPCDarkMode == 2,
            'pc-search': isPC,
            'pcview-tplsearch': isNewPcView,
        }"
        :style="fixLeft"
    >
        <div class="tpl-searchbox">
            <AutoComplete
                ref="autoComplete"
                v-model="keyword"
                v-click-outside="blur"
                @mousedown.native="clickPrevent()"
                class="tpl-search--input"
                :placeholder="`搜索使用${worksCount}个绘图模板`"
                @on-change="changeInput"
                @on-select="selectHistory"
                @on-focus="uploadData"
                @keydown.native.enter="search()"
                @keydown.native="mockDelete($event)"
                @input.native="cleanEmoji"
                :data-locate="'store-search'"
            >
                <div v-if="history.length > 0" class="auto-complete--history-ope">
                    <div>{{ $t("history") }}</div>
                    <div class="auto-complete--history-ope--icon" @click="clearHistory">
                        <Icon type="md-trash" size="16" />
                        <span>{{ $t("clear") }}</span>
                    </div>
                </div>
                <i-option v-for="item in history" :key="item.id" :value="item" :title="item">{{ item }}</i-option>
                <div v-if="hotWord.length > 0" class="auto-complete--history-ope">{{ $t("trending") }}</div>
                <div class="hot-list-item" v-if="hotWord.length > 0">
                    <li v-for="item in hotWord" :key="item.id" @click="searchHotWord(item.name)" v-if="item.name != ''">
                        <span class="hot-id">{{ item.id }}</span>
                        <span>{{ item.name }}</span>
                    </li>
                </div>
            </AutoComplete>
            <div class="tpl-search--icon" :data-locate="'store-search-btn'" @click="search()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.5">
                        <circle cx="11" cy="11" r="6.5" stroke="inherit" />
                        <path d="M16 16L21 21" stroke="inherit" stroke-linecap="round" />
                    </g>
                </svg>
            </div>
            <div class="tpl-clean--icon" :class="{ active: keyword.length > 0 }" :data-locate="'store-clean-btn'" @click.stop="cleanSearchInput()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.2924 12L7 16.2924L7.70761 17L12 12.7076L16.2924 17L17 16.2924L12.7076 12L17 7.70761L16.2924 7L12 11.2924L7.70761 7L7 7.70761L11.2924 12Z"
                        fill="#424242"
                    />
                </svg>
            </div>
        </div>

        <Dropdown class="tpl-search-dropdown" v-if="showSearch && internal">
            <div class="search-dropdown-title">
                <div class="dropdown-svgicon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="2" width="12" height="1" rx="0.5" fill="#0977EA" />
                        <rect x="2" y="7" width="12" height="1" rx="0.5" fill="#0977EA" />
                        <rect x="2" y="12" width="12" height="1" rx="0.5" fill="#0977EA" />
                    </svg>
                </div>
                <p>{{ activeLv1.lv1name || activeLv1[0].lv1name }}</p>
            </div>
            <DropdownMenu slot="list">
                <DropdownItem class="search-dropItem" v-for="item in editorTags" :key="item.lv1id" @click.native="toWorkClass(item)">
                    <span class="search-dropItem-text">{{ item.lv1name }}</span>
                    <span v-show="activeLv1.lv1name == item.lv1name">
                        <iconSymbol style="width: 20px; height: 20px" name="search_select" />
                    </span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>

        <div class="tpl-search--hots">
            <span v-for="item in hotTags" :key="item.id" class="tpl-search--hot" @click="searchByTag(item)">{{ item }}</span>
        </div>

        <div class="tpl-search--trending" v-if="!internal && !showSearch">
            <div>
                <p>{{ $t("trending") }}:</p>
                <ul>
                    <li v-for="item in hotKey" :key="item.id" @click="searchHotkey(item.name)">
                        <p>{{ item.name }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        props: {
            searchWord: {
                type: String,
                default: "",
            },
            searchLang: {
                type: String,
                default: "en",
            },
        },
        data() {
            return {
                keyword: "",
                history: [],
                allHistory: [],
                isSearching: false,
                hotTags: [],
                hotWord: [
                    { id: 1, name: "软件架构" },
                    { id: 2, name: "甘特图" },
                    { id: 3, name: "时序图" },
                    { id: 4, name: "流程图" },
                    { id: 5, name: "组织结构图" },
                    { id: 6, name: "网络图" },
                ],
                hotKey: [],
                timer: -1,
                notCloseFlag: false,
                showSearch: false,
            };
        },
        created() {
            this.getAllHistory();
            this.updateHistoryList();
            !this.internal && this.getHotKey();
            this.getHotWord();
            //热门标签
            // this.$edApi.getHotTags(this.params).then(tags => {
            //     this.hotTags = tags;
            // });
            this.$bus.$on("setSearchKey", this.setSearchKey);
            this.$bus.$on("clearSearch", this.clearSearch);
            this.$once("hook:beforeDestroy", () => {
                this.$bus.$off("setSearchKey", this.setSearchKey);
                this.$bus.$off("clearSearch", this.clearSearch);
            });
        },
        mounted() {
            let dom = document.querySelector(".store-box");
            dom.addEventListener("scroll", this.scrollFit);
            this.$once("hook:beforeDestroy", () => {
                dom.removeEventListener("scroll", this.scrollFit);
            });
        },
        computed: {
            editorTags() {
                return this.$store.state.tplCenter.editorTags;
            },
            worksCount() {
                return this.$store.state.worksCount;
            },
            activeLv1() {
                return this.$store.state.activeLv1;
            },
            fixLeft() {
                if (this.showSearch) {
                    if (this.isPC) return "width:100%;left:0";
                    else return "width:calc(100% - 210px);left:210px;top:45px";
                }
            },
            isNewPcView() {
                return this.isPC && this.$isBiggerVersion("13.0.0");
            },
        },
        methods: {
            scrollFit(e) {
                let st = e.target.scrollTop;
                let event = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    clientX: -100,
                    clientY: -100,
                });
                document.body.dispatchEvent(event);
                if (st > 1000) return;
                this.showSearch = st >= 400;
            },
            toWorkClass(lv1) {
                this.$bus.$emit("selectWorkClass", {
                    refreshTemplate: true,
                    lv1,
                });
                if (lv1) {
                    window.$qt &&
                        window.$qt.jsCallUploadData &&
                        window.$qt.jsCallUploadData(
                            JSON.stringify({
                                type: "Templates",
                                action: "clickFloatSearchBox",
                                event: "experience",
                                label: JSON.stringify({
                                    diagram_type: lv1.lv1name,
                                }),
                            })
                        );
                }
            },
            clickPrevent() {
                this.notCloseFlag = true;
                document.onmouseup = () => {
                    setTimeout(() => {
                        this.notCloseFlag = false;
                        document.onmouseup = null;
                    }, 0);
                };
            },
            setSearchKey(data, aa = "init") {
                this.keyword = data;
                if (aa == "init") {
                    this.$store.commit("toTplCenter", {
                        name: "notInitTemplates",
                        data: true,
                    });
                }
                this.search();
            },
            clearSearch() {
                this.keyword = "";
                this.$emit("search", { doSearch: false, keyword: "" });
            },
            blur() {
                console.log(this.notCloseFlag);
                if (this.notCloseFlag) return;
                this.$refs.autoComplete.$el.getElementsByTagName("input")[0].blur();
                setTimeout(() => {
                    this.updateHistoryList();
                }, 500);
            },
            clearHistory() {
                localStorage.removeItem("search-history");
                this.allHistory = [];
                this.history = [];
            },
            getAllHistory() {
                let data = localStorage.getItem("search-history");
                if (data) {
                    this.allHistory = data.split(",");
                }
            },
            //更新显示的搜索历史列表
            updateHistoryList() {
                if (this.isSearching) return;

                if (this.allHistory.length > 5) {
                    let arr = this.allHistory.slice(this.allHistory.length - 5, this.allHistory.length);
                    this.history = arr.reverse();
                } else {
                    this.history = [].concat(this.allHistory).reverse();
                }

                this.history = this.history.splice(0, 5);
            },
            changeInput() {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    if (this.keyword == "") {
                        this.$bus.$emit("selectWorkClass", {
                            refreshTemplate: false,
                            lv1: this.editorTags[0],
                        });
                        this.$emit("search", { doSearch: true, keyword: "" });
                    }
                }, 500);
            },
            updateHistory(word) {
                //更新历史记录
                let oldHistory = localStorage.getItem("search-history") || "",
                    newHistory,
                    index = this.allHistory.indexOf(word);
                if (index != -1) {
                    //已经存在记录，把记录放到最前面
                    this.allHistory.splice(index, 1);
                    oldHistory = this.allHistory.join(",");
                }
                if (oldHistory) {
                    newHistory = oldHistory + "," + word;
                } else {
                    newHistory = word;
                }

                console.log(newHistory);
                localStorage.setItem("search-history", newHistory);
                this.getAllHistory();
                this.updateHistoryList();
            },
            search() {
                //搜索
                let keyword = this.keyword.trim().replace(/\s+/g, " ");
                if (keyword) {
                    //keyword不为空
                    this.updateHistory(keyword);
                }
                if (this.isSearching) return;

                if (this.isPC) {
                    // window.$qt.jsCallUploadData &&
                    //     window.$qt.jsCallUploadData(
                    //         JSON.stringify({
                    //             type: this.internal ? "S006_Use_Template_8" : "S018_Use_Template_EN",
                    //             action: this.internal ? "SL037_Click_Search" : "SL111_Click_Search",
                    //         })
                    //     );
                }
                //更新作品
                this.$emit("search", { doSearch: true, keyword, stopResetClass: true });
            },
            cleanSearchInput() {
                this.keyword = "";
                this.search();
            },
            uploadData() {
                if (this.isPC) {
                    let location = "Template Community Home page";
                    if (this.$store.state.tplCenter.albumPageStatus == "detail") {
                        location = "Album List page";
                    } else if (this.$store.state.tplCenter.albumPageStatus == "list") {
                        location = "All album pages";
                    }

                    window.$qt.jsCallUploadData &&
                        window.$qt.jsCallUploadData(
                            JSON.stringify({
                                // type: this.internal ? "S006_Use_Template_8" : "S018_Use_Template_EN",
                                // action: this.internal ? "SL036_Search_Box" : "SL110_Search_Box",
                                type: "Templates",
                                action: "searchBox",
                                event: "experience",
                                label: JSON.stringify({
                                    search_location: location,
                                }),
                            })
                        );
                } else {
                    this.sensors.track("searchBox", {
                        Catalogues: "Templates",
                    });
                }
            },
            selectHistory(keyword) {
                //查找被点击的记录
                console.log(keyword);
                if (this.isSearching) return;
                this.updateHistory(keyword);
                this.keyword = keyword;

                //更新作品
                this.$bus.$emit("selectWorkClass", {
                    refreshTemplate: false,
                    lv1: this.editorTags[0],
                });
                this.$emit("search", { doSearch: true, keyword });
                this.isSearching = true;
                setTimeout(() => {
                    this.isSearching = false;
                }, 0);
            },
            searchByTag(tag) {
                if (this.isSearching) return;
                this.updateHistory(tag);

                this.keyword = tag;
                //更新作品
                this.$emit("searchByTag", tag);
                setTimeout(() => {
                    this.$refs.autoComplete.$el.getElementsByClassName("ivu-select-dropdown")[0].style.display = "none";
                }, 0);
            },
            getHotKey() {
                this.$edApi
                    .getSearchHotkey({
                        lang: this.searchLang || "en",
                        count: 7,
                    })
                    .then((e) => {
                        this.hotKey = e;
                    });
            },
            getHotWord() {
                this.$edApi
                    .getSearchHotkey({
                        lang: this.lang || "zh",
                        count: 7,
                    })
                    .then((e) => {
                        this.hotWord = e;
                    });
            },
            searchHotWord(name) {
                this.keyword = name;
                //更新作品
                this.$bus.$emit("selectWorkClass", {
                    refreshTemplate: false,
                    lv1: this.editorTags[0],
                });
                this.$emit("search", { doSearch: true, keyword: name });
                this.$refs.autoComplete.$el.__vue__.hideMenu();
                this.updateHistory(name);
            },
            searchHotkey(name) {
                this.keyword = name;

                if (this.isPC) {
                    // window.$qt.jsCallUploadData &&
                    //     window.$qt.jsCallUploadData(
                    //         JSON.stringify({
                    //             type: this.internal ? "S006_Use_Template_8" : "S018_Use_Template_EN",
                    //             action: this.internal ? "SL037_Click_Search" : "SL111_Click_Search",
                    //         })
                    //     );
                }
                //更新作品
                this.$emit("search", { doSearch: true, keyword: name });
            },
            cleanEmoji(e) {
                e.target.value = e.target.value.replace(
                    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
                    ""
                );
            },
            mockDelete(e) {
                if (e.keyCode == 46 || e.keyCode == 8) {
                    e.preventDefault();
                    let start = e.target.selectionStart;
                    let end = e.target.selectionEnd;
                    let endPosition = 0;
                    if (start == end) {
                        if (e.keyCode == 46) {
                            this.keyword = this.keyword.substring(0, start) + this.keyword.substring(start + 1, this.keyword.length);
                            endPosition = start;
                        } else {
                            this.keyword = this.keyword.substring(0, start - 1) + this.keyword.substring(start, this.keyword.length);
                            endPosition = start - 1;
                        }
                    } else {
                        this.keyword = this.keyword.substring(0, start) + this.keyword.substring(end, this.keyword.length);
                        endPosition = start;
                    }
                    this.changeInput();
                    this.$nextTick(() => {
                        e.target.selectionStart = e.target.selectionEnd = endPosition;
                    });
                }
            },
        },
    };
</script>

<i18n>
{
  "zh": {
    "search": "搜索",
    "history": "搜索历史",
    "clear": "清空",
    "trending": "搜索热词"
  },
  "en": {
    "search": "Search",
    "history": "History",
    "clear": "Empty",
    "trending": "Trending searches"
  },
  "de": {
    "search": "suchen nach",
    "history": "Suchverlauf",
    "clear": "Leer",
    "trending": "Trendsuchen"
  },
  "fr": {
    "search": "rechercher",
    "history": "historique des recherches",
    "clear": "Vide",
    "trending": "Recherches populaires"
  },
  "es": {
    "search": "buscar",
    "history": "buscar Historia",
    "clear": "Vacío",
    "trending": "Tendencias de búsquedas"
  },
  "jp": {
    "search": "検索する",
    "history": "検索履歴",
    "clear": "空きにする",
    "trending": "検索キーワード"
  },
  "it": {
    "search": "Cercare",
    "history": "cronologia delle ricerche",
    "clear": "Vuoto",
    "trending": "Ricerche di tendenza"
  },
  "pt": {
    "search": "procurar por",
    "history": "histórico de busca",
    "clear": "Vazio",
    "trending": "Tendências de pesquisas"
  },
  "tw": {
    "search": "搜尋",
    "history": "搜尋歷史",
    "clear": "清空",
    "trending": "搜尋熱詞"
  },
  "kr": {
    "search": "찾기",
    "history": "조회 기록",
    "clear": "지우기",
    "trending": "인기많은 검색어"
  },
  "id": {
    "search": "Cari",
    "history": "Riwayat",
    "clear": "Kosong",
    "trending": "Pencarian yang sedang tren"
  }
}
</i18n>
